import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import editedFlagMixin from '../../mixins/_edited_flag';
import editHistory from '../../components/static_html_editor/_edit_history';

// ステップ定義
const STEP_NAMES = [
    'カテゴリをつくる',
    'テンプレートを選ぶ',
    '商品情報の入力',
    'デザインの作成',
];

/**
 * 共通専用ヘッダーコンポーネント
 */
export default {
    name: 'commonHeader',
    template: '#common_header_component_template',
    data () {
        return {
            // 設定が変更されたか否かのフラグ
            edited: false,
            // 変更一つ前のitem_dataデータ
            old_item_data: {},
        };
    },
    props: {
        // 編集か新規か new|edit
        type: {
            type: String,
            require: true
        },
        // v-model現在のステップ
        step: {
            type: Number,
            default: 1,
            require: true
        },
        // 商品データ
        item_data: {
            type: Object,
            default: () => ({})
        },
        // 編集ID
        edit_id: {
            type: [String, Number],
            require: true
        },
        // 下書き保存ボタン表示フラグ
        show_save_btn: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        // Undo / Redoコンポーネント
        'edit-history': editHistory,
    },
    computed: {
        // 新規商品登録のカテゴリ・テンプレート選択画面か
        isNewItemFirstFlow: function () {
            if (this.type === 'new' && this.step <= 2) {
                return true;
            }
            return false;
        },
        // ステップ一覧表示用データ
        steps: function () {
            let steps = [];
            for (const i in STEP_NAMES) {
                if (this.type === 'edit' && i < 2) {
                    continue;
                }

                const step = steps.length + 1;
                const name = (this.step === step) ? STEP_NAMES[i] : '';
                let className = '';
                if (this.step === step) {
                    className = 'active';
                } else if (this.step < step) {
                    className = 'undone';
                }
                steps.push({
                    no: step,
                    name: name,
                    class: className,
                });
            }
            return steps;
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        editedFlagMixin,
    ],
    watch: {
        // 編集完了時処理
        edited: function (value) {
            if (value === false) this.$refs.editHistory.clearHistory();
        },
    },
    mounted: function () {
        // 共通グローバルヘッダ非表示
        this.$_showGlobalHeader(false);
    },
    created: function () {
        // 未保存アラート機能初期化(item_dataを対象とする)
        this.iniEditedFlag('item_data', () => (!this.isNewItemFirstFlow));
    },
    emits: ['update:step'],
    methods: {
        // プレビューを表示
        showPreview: async function () {
            if (await this.$root.$refs.itemEditor.validation()) {
                this.$root.$refs.preview.show(this.item_data.name, this.item_data);
            }
        },
        // 下書き保存
        save: async function () {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post('/item/save', {
                    _method: 'PUT',
                    edit_id: this.edit_id,
                    copy_id: this.$_copyId(),
                    item_data: this.item_data,
                });
                if (response.data.status === 'OK') {
                    // エラーメッセージを空にする
                    message = '';
                    this.appendFlashMessage({
                        level: 'alert-info',
                        message: '保存しました',
                        autoClear: true
                    }, this.$parent);
                    this.updateEdited(false);
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 戻るボタンをクリック
        prevStep: async function () {
            // ステップ1 or adminでステップ2の場合は一覧へ戻る
            if (this.step === 1 || (this.step === 2 && this.isAdmin)) {
                // 編集時は未保存をチェック
                if (this.type === 'edit' && !await this.destConfirm()) {
                    return;
                }
                window.location.href = '/item';
                return;
            }
            // 新規追加時、商品情報から戻る場合
            if (this.type === 'new' && this.step === 3 && !await this.destConfirm()) {
                return;
            }
            this.emitPrevStep();
        },

        // -------------------------
        // emit
        // -------------------------

        // 戻るボタンをクリックしたら通知
        emitPrevStep: function () {
            this.$emit('update:step', this.step - 1);
        }
    }
};
